export const NotificationTypes = {
  PUBLIC: 1,
  INTERNAL: 2,
  USER: 3,
  USER_GROUP: 4,
  SERVICE: 5,
};
